
import { Vue, Component } from 'vue-property-decorator'

import {
  GQL_LOCAL_MUTATION_SET_UI,
  GQL_LOCAL_UI,
} from '~/graphql/gqlLocal/localUi'
import {
  GQLLocalUi,
  GQLLocalUiInput,
} from '~/graphql/__generated__/interfacesLocal'
import { SET_HEADER_VISIBILITY } from '~/graphql/gqlLocal/localHeader'

const ModalCrossSell = () => import('~/components/modal/ModalCrossSell.vue')

interface GlobalModalHeaderOpen {
  isOpen: boolean
  ui: GQLLocalUiInput
  disabledScrollBack?: boolean
}

@Component({
  apollo: {
    ui: {
      query: GQL_LOCAL_UI,
    },
  },
  components: { ModalCrossSell },
})
export default class GlobalModalHeader extends Vue {
  ui: GQLLocalUi
  scrollY: number

  open(isOpen: GlobalModalHeaderOpen) {
    const mainContentElement = document.getElementById('main-content')

    if (!mainContentElement) {
      return
    }

    if (isOpen.isOpen) {
      this.menuDesktopHiddenList(true)

      this.scrollY = window.scrollY

      mainContentElement.style.display = 'none'

      window.scrollTo(0, 0)
      return
    }

    this.menuDesktopHiddenList(false)

    mainContentElement.style.display = 'block'

    if (!isOpen.disabledScrollBack) {
      window.scrollBy(0, this.scrollY)
      this.scrollY = window.scrollY
    }

    this.$apollo.mutate({
      mutation: GQL_LOCAL_MUTATION_SET_UI,
      variables: { ui: isOpen.ui } as GQLLocalUiInput,
    })
  }

  menuDesktopHiddenList(menuDesktopHiddenList: boolean) {
    this.$apollo.mutate({
      mutation: SET_HEADER_VISIBILITY,
      variables: {
        menuDesktopHiddenList,
      },
    })
  }
}
